

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { memo } from "react";
import styles from "../../styles/components/custombutton.module.scss";


const CustomButtonMemo = ({
  children,
  variant = "contained",
  disabled = false,
  onClick,
  color = "inherit",
  size = "medium",
  fullWidth = false,
  endIcon,
  startIcon,
  type,
  loading = false
}) => {

  return (
    <Button
      className={styles.button}
      variant={variant}
      disabled={disabled || loading}
      disableElevation
      onClick={onClick}
      color={color}
      size={size}
      fullWidth={fullWidth}
      endIcon={endIcon}
      startIcon={startIcon}
      type={type}

    >
      {loading && <CircularProgress style={{marginRight: 8}} size={15} color="inherit" />}
      {children}
    </Button>
  );
};

const CustomButton = memo(CustomButtonMemo);

export default CustomButton;
